import { useQuery, UseQueryResult } from "@tanstack/react-query";
import api, { ApiCatalog, RestApiOptions } from "@/api";
import { IStandardAggregationsResponse } from "@/search/Langston/types/IStandard";

const oneMinuteInMilliseconds = 60000;

export const useStandardAggregationsQuery = (): UseQueryResult<
  IStandardAggregationsResponse,
  Error
> => {
  const apiOptions: RestApiOptions = {
    timeout: oneMinuteInMilliseconds,
  };

  return useQuery<IStandardAggregationsResponse, Error>({
    queryKey: [ApiCatalog.standardAggregations.key],
    enabled: true,
    queryFn: () => {
      return api(apiOptions).get<IStandardAggregationsResponse>(
        `${ApiCatalog.standardAggregations.endpoint}`,
      );
    },
  });
};

export default useStandardAggregationsQuery;
